import React from 'react'

type Props = {
    theme: string
    actions: Actions
    stage: string
    status: string

    user_guid: string | null
    contract_user_guid: string
    contract_supervisor_user_guid: string
    role: string

    contractAction: boolean
    approve: boolean
    isHaveError: boolean
    lastApprovalStatus: boolean
    lastApprovalStatusAccept: boolean
    organizationApproval?: boolean
    isUpdatingFromEis?: boolean
}

type Actions = {
    return_to_edit: () => void
    return_to_ready: () => void
    ready: () => void
    edit: () => void
    edit_ready: () => void
    ready_to_sent: () => void
    ready_to_eis: () => void
    send_to_eis: () => void
    update: () => void // Обновить из ЕИС
    validation: () => void
}

type ButtonConfig = {
    id: string
    label: string
    onClick: () => void
    visibleCondition: boolean // Функция, проверяющая видимость
    className?: string // Стили для кнопки
    iconPathD: string
    iconFill: string
    disabled: boolean
    isLoading: boolean
}

const FooterLeftToolbarButtons: React.FC<Props> = ({
    theme,
    actions,
    stage,
    status,

    user_guid,
    contract_user_guid,
    contract_supervisor_user_guid,
    role,

    contractAction,
    approve,
    isHaveError,
    lastApprovalStatus,
    lastApprovalStatusAccept,
    organizationApproval,
    isUpdatingFromEis,
}) => {
    const isCreatorSupervisor =
        user_guid === contract_user_guid ||
        user_guid === contract_supervisor_user_guid
    const isAdmin = role === 'admin'
    const isSpecialist = role === 'specialist'
    const isCurator = role === 'curator'
    const isInitiator = role === 'initiator'

    const isEditStage = stage === 'Редактирование'
    const isRaedyStage = stage === 'Подготовка к размещению'
    const isSentToEisStage = stage === 'Отправка в ЕИС'
    const isPerformanceContractStage = stage === 'Размещенное исполнение'

    const isEditStatus = status === 'Черновик'
    const isReadyStatus = status === 'Готово'
    const isStandStatus = status === 'Подготовка'
    const isReadyToEisStatus = status === 'Готово к отправке'
    const isSentToEisStatus = status === 'Отправлено в ЕИС'
    const isPublishedStatus = status === 'Размещена'

    const isApprovalAccept = lastApprovalStatusAccept === true

    const isActiveApproval = organizationApproval
        ? organizationApproval === true
        : false

    const buttons: ButtonConfig[] = [
        {
            id: 'return_to_edit',
            label: 'Вернуть',
            onClick: actions.return_to_edit,
            visibleCondition:
                !approve &&
                isRaedyStage &&
                isStandStatus &&
                (isSpecialist || isAdmin),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M21,11H9.41l2.3-2.29a1,1,0,1,0-1.42-1.42l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H21a1,1,0,0,0,0-2ZM3,3A1,1,0,0,0,2,4V20a1,1,0,0,0,2,0V4A1,1,0,0,0,3,3Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'return_to_ready',
            label: 'Вернуть',
            onClick: actions.return_to_ready,
            visibleCondition:
                !approve &&
                isSentToEisStage &&
                isReadyToEisStatus &&
                (isSpecialist || isAdmin),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M21,11H9.41l2.3-2.29a1,1,0,1,0-1.42-1.42l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H21a1,1,0,0,0,0-2ZM3,3A1,1,0,0,0,2,4V20a1,1,0,0,0,2,0V4A1,1,0,0,0,3,3Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'validation',
            label: 'Проверить',
            onClick: actions.validation,
            visibleCondition:
                (!approve &&
                    isEditStage &&
                    isEditStatus &&
                    (isAdmin || isSpecialist || isCreatorSupervisor)) ||
                (!approve &&
                    isRaedyStage &&
                    isStandStatus &&
                    (isAdmin || isSpecialist)),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs shadow-md shadow-[#18181830] ${isReadyStatus ? 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]' : 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]'}`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z',
            disabled: isReadyStatus,
            isLoading: false,
        },
        {
            id: 'ready',
            label: 'Готово',
            onClick: actions.ready,
            visibleCondition:
                (!approve &&
                    isEditStage &&
                    isEditStatus &&
                    (isAdmin || isSpecialist || isCreatorSupervisor)) ||
                (!approve &&
                    isRaedyStage &&
                    isStandStatus &&
                    (isAdmin || isSpecialist)),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isReadyStatus || isHaveError ? 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#EDEDED] dark:bg-[#494849]' : 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]'}`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z',
            disabled: isReadyStatus || isHaveError,
            isLoading: false,
        },
        {
            id: 'edit',
            label: 'Редактировать',
            onClick: actions.edit,
            visibleCondition:
                !approve &&
                lastApprovalStatus &&
                isEditStage &&
                isReadyStatus &&
                (isAdmin || isSpecialist || isCreatorSupervisor),
            className:
                'flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]',
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'edit_ready',
            label: 'Редактировать',
            onClick: actions.edit_ready,
            visibleCondition:
                !approve &&
                isRaedyStage &&
                isReadyStatus &&
                (isAdmin || isSpecialist),
            className:
                'flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]',
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'ready_to_sent',
            label: 'Направить на подготовку к размещению',
            onClick: actions.ready_to_sent,
            visibleCondition:
                !approve &&
                isEditStage &&
                isReadyStatus &&
                (isAdmin ||
                    isSpecialist ||
                    ((isApprovalAccept || !isActiveApproval) && isCurator)),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isEditStage && isReadyStatus ? 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]' : 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#EDEDED] dark:bg-[#494849]'}`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !(isEditStage && isReadyStatus),
            isLoading: false,
        },
        {
            id: 'ready_to_eis',
            label: 'Подготовить к отправке в ЕИС',
            onClick: actions.ready_to_eis,
            visibleCondition:
                !approve && isRaedyStage && (isAdmin || isSpecialist),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isRaedyStage && isReadyStatus ? 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]' : 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#EDEDED] dark:bg-[#494849]'}`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !(isRaedyStage && isReadyStatus),
            isLoading: false,
        },
        {
            id: 'ready_to_eis',
            label: 'Отправить в ЕИС',
            onClick: actions.send_to_eis,
            visibleCondition:
                !approve &&
                isSentToEisStage &&
                isReadyToEisStatus &&
                (isAdmin || isSpecialist),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isSentToEisStage && isReadyToEisStatus ? 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]' : 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#EDEDED] dark:bg-[#494849]'}`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !(isSentToEisStage && isReadyToEisStatus),
            isLoading: false,
        },
        {
            id: 'update',
            label: 'Обновить данные',
            onClick: actions.update,
            visibleCondition:
                !approve &&
                !contractAction &&
                ((isSentToEisStage && isSentToEisStatus) ||
                    (isPerformanceContractStage && isPublishedStatus)) &&
                (isAdmin || isSpecialist),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${
                (isSentToEisStage && isSentToEisStatus) ||
                (isPerformanceContractStage && isPublishedStatus)
                    ? 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]'
                    : 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#EDEDED] dark:bg-[#494849]'
            }`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !(
                (isSentToEisStage && isSentToEisStatus) ||
                (isPerformanceContractStage && isPublishedStatus)
            ),
            isLoading: false,
        },
    ]

    return (
        <>
            {buttons
                .filter((button) => button.visibleCondition) // Оставляем только видимые кнопки
                .map((button, index) => (
                    <button
                        key={index}
                        className={button.className}
                        onClick={button.onClick}
                        // title={button.label}
                        disabled={button.disabled}
                    >
                        {button.isLoading || isUpdatingFromEis ? (
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                        ) : (
                            ''
                        )}
                        {button.label}
                    </button>
                ))}
        </>
    )
}

export default FooterLeftToolbarButtons
